
<template>
  <div class="bene-info">
    <el-descriptions
      class="margin-top"
      title="Customer info"
      :column="2"
      size="mini"
      border
    >
      <el-descriptions-item>
        <template slot="label"> Member Code </template>
        {{ info.membercode }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label"> Customer type </template>
        {{ info.customerType }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label"> Customer name </template>
        {{ info.customerName }}
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions
      class="margin-top"
      title="Beneficiary info"
      :column="3"
      size="mini"
      border
    >
      <el-descriptions-item>
        <template slot="label"> Name </template>
        {{ info.name }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label"> Currency </template>
        {{ info.currency }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label"> Status </template>
        {{ info.status.toUpperCase() }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> Type </template>
        {{ info.type.toUpperCase() }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> Account number </template>
        {{ info.accountnumber }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> Sortcode </template>
        {{ info.sortcode }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> IBAN </template>
        {{ info.iban }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> BIC </template>
        {{ info.bic }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
export default {
  props: {
    info: Object,
  },
};
</script>

<style lang="scss">
.bene-info {
  margin-bottom: 16px;
  .margin-top {
    margin-top: 20px;
  }
}
</style>